/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import {
    Component,
    Type,
} from '@angular/core';

import {
    AviPermissionResource,
    IReportProfile,
} from 'generated-types';

import { ObjectTypeItem } from 'ajs/modules/data-model/factories';
import { withFullModalMixin } from 'ajs/js/utilities/mixins';
import { TWindowElement } from 'ajs/modules/data-model/data-model.types';

interface IIReportProfileData {
    config: IReportProfile;
}

export type TReportProfileItem = typeof ReportProfileItem;

/**
 * @description Report Profile Item
 * @author Deepak Chaudhary
 */
export class ReportProfileItem extends withFullModalMixin(ObjectTypeItem) {
    public getConfig: () => IReportProfile;
    public data: IIReportProfileData;

    constructor(args = {}) {
        const extendedArgs = {
            objectName: 'reportprofile',
            objectType: 'ReportProfile',
            windowElement: 'lazy-load',
            permissionName: AviPermissionResource.PERMISSION_REPORTPROFILE,
            ...args,
        };

        super(extendedArgs);
    }

    /**
     * Import lazy-loaded modal component.
     */
    public async getModalComponent(windowElement: TWindowElement): Promise<Type<Component>> {
        const {
            ReportProfileModalComponent,
        } = await import(
            /* webpackChunkName: "update-profile-modal" */
            'ng/lazy-loaded-components/modals/report-profile-modal/report-profile-modal.component'
        );

        return ReportProfileModalComponent as Type<Component>;
    }

    /** @override */
    public urlToSave(): string {
        return `/api/${this.objectName}`;
    }

    /** @override */
    public async loadConfig(): Promise<ng.IHttpResponse<IReportProfile>> {
        const url = `/api/${this.objectName}`;

        this.cancelRequests('config');

        const response: ng.IHttpResponse<IReportProfile> =
            await this.request('get', url, undefined, null, 'config');

        this.onConfigLoad_(response);

        return response;
    }
}
